/** Erro de um pedido, com o estado HTTP quando o houve (sem estado = rede). */
export class RequestError extends Error {
  constructor(
    message: string,
    readonly status: number | null,
    readonly details?: unknown,
  ) {
    super(message)
  }
}

/**
 * O client do SDK lança em respostas ≠ 2xx (com o estado e o corpo); sem
 * resposta nenhuma é rede. Converte para `RequestError` — a fila de leituras
 * decide por aqui se repete (rede/5xx) ou desiste (recusa 4xx).
 */
export function toRequestError(e: unknown): RequestError {
  if (e instanceof RequestError) return e
  const err = e as { status?: number; body?: { error?: string; details?: unknown }; message?: string }
  const status = typeof err.status === "number" ? err.status : null
  // Um `success: false` com 200 (unwrap) é uma recusa, não rede.
  const refused = status === null && e instanceof Error && !(e instanceof TypeError) && !/network|fetch|load failed/i.test(e.message)
  if (status === null && !refused) return new RequestError("Sem rede — a tentar outra vez.", null)
  return new RequestError(err.body?.error ?? err.message ?? "Sem rede", refused ? 400 : status, err.body?.details)
}
